import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import { TrackedObject } from 'tracked-built-ins';

import Model from 'umg-ember-backend/models/variant-model';
import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations();

export const settings = {
  copyableOptions: {
    ignoreAttributes: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
    ],
  },
  saveHooks: {
    after: [saveHasManyRelationships('contributors')],
  },
  variantProperties: [
    'additionalDescription',
    'additionalProductInfo',
    'alphaInformation',
    'alternativeHeadline',
    'alternativeSubHeadlines',
    'artistDescription',
    'cmsLanguageId',
    'seoTitle',
    'seoDescription',
    'keywords',
    'seoImage',
    'cmsState',
    'headline',
    'repertoireDescription',
  ],
};

export default class ProductFamilyModel extends Model.extend(Validations) {
  @attr('string') additionalDescription;
  @attr('string') additionalProductInfo;
  @attr('string') alphaId;
  @attr('json', {
    defaultValue() {
      return new TrackedObject({});
    },
  })
  alphaInformation;
  @attr('string') alternativeHeadline;
  @attr('string') alternativeSubHeadlines;
  @attr('string') artistDescription;
  @attr('number') catmamaId;
  @attr('string') color;
  @attr('string') headline;
  @attr('boolean') isClassicalDiscography;
  @attr('string') repertoireDescription;
  @attr('boolean') videoAdsInactive;

  // CMS fields
  @attr('string') seoTitle;
  @attr('string') seoDescription;
  @attr('string') keywords;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('category', { async: true, inverse: null }) categories;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;
  @belongsTo('channel', { async: true, inverse: null }) ownedByChannel;
  @hasMany('product-family-contributor', {
    async: true,
    inverse: 'productFamily',
  })
  contributors;
  @hasMany('product', { async: true, inverse: null }) products;
  @hasMany('taxon', { async: true, inverse: null }) taxa;
  @hasMany('web-series', { async: true, inverse: null }) webSeries;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return `${this.headline} (${this.id})`;
  }

  get showAlphaInformation() {
    return (
      this.alphaInformation &&
      (this.alphaInformation.title ||
        this.alphaInformation.artists?.length ||
        this.alphaInformation.projectName ||
        this.alphaInformation.originalProducts?.length)
    );
  }

  get mainProduct() {
    return this.products[0];
  }
}
